import { JsonObject } from 'json2typescript';
import { FinancialPlanRefdataInterface } from '../interfaces/financialplan-refdata.interface';
import { Profile } from './profile.model';
import { Target } from '../../../publicplanner/request/models/target.model';


@JsonObject('FinancialPlanRefdata')
export class FinancialPlanRefdata implements FinancialPlanRefdataInterface {
  AvgLifeExpectancy?: number;
  BaseCurrency?: string;
  BaseInflation?: number;
  BaseRetirementAge?: number;
  ClientAge?: number;
  GrowDefaultYears?: number;
  ProfileId?: number;
  Profiles?: Profile[];
  Targets?: Target[];
  Taxes?: number;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
